import { ItemsImgList } from "./items-img-list";

// Product Tag
export type ProductTags = "nike" | "puma" | "lifestyle" | "caprese";

// Product Colors
export type ProductColor =
  | "white"
  | "black"
  | "red"
  | "green"
  | "purple"
  | "yellow"
  | "blue"
  | "gray"
  | "orange"
  | "pink";

export class Product {
  idItemEC?: number;
  TItemEC?: string;
  TItemECNom?: string;
  idItem?: number;
  Marca?: string;
  Codigo?: string;
  Nro?: number;
  NombreItm?: string;
  UniMed?: string;
  UniMedDeno?: string;
  CodigoBarras?: string;
  APedido?: boolean;
  TED?: number;
  TipoIGV?: string;
  PV1?: number;
  PV2?: number;
  PV3?: number;
  PV4?: number;
  PV5?: number;
  PV6?: number;
  PVVenta?: number;
  PorcDscto?: string;
  SaldoG?: number;
  Otros?: string;
  ImagenP?: string;
  ClicCant?: number;
  ValCant?: number;
  ValSum?: number;
  ValProm?: number;
  Habilitado?: boolean;
  IncICBPER?: boolean;
  Mostrar?: boolean;
  OrdenIEC?: number;
  Filial?: string;
  items_Img_List?: ItemsImgList[];
  itemsEC_Img_List?: ItemsImgList[];
  tags?: ProductTags[];
  colors?: ProductColor[];
  OtrosEC?: any;
  itemsEC_Atributos_List?: any[];
  Filial_Data?: any;

  constructor(
    idItemEC?: number,
    TItemEC?: string,
    TItemECNom?: string,
    idItem?: number,
    Marca?: string,
    Codigo?: string,
    Nro?: number,
    NombreItm?: string,
    UniMed?: string,
    UniMedDeno?: string,
    CodigoBarras?: string,
    APedido?: boolean,
    TED?: number,
    TipoIGV?: string,
    PV1?: number,
    PV2?: number,
    PV3?: number,
    PV4?: number,
    PV5?: number,
    PV6?: number,
    PVVenta?: number,
    PorcDscto?: string,
    Saldo?: number,
    SaldoG?: number,
    Otros?: string,
    ImagenP?: string,
    ClicCant?: number,
    ValCant?: number,
    ValSum?: number,
    ValProm?: number,
    Habilitado?: boolean,
    IncICBPER?: boolean,
    Mostrar?: boolean,
    OrdenIEC?: number,
    Filial?: string,
    items_Img_List?: ItemsImgList[],
    itemsEC_Img_List?: any[],
    tags?: ProductTags[],
    colors?: ProductColor[],
    OtrosEC?: any,
    itemsEC_Atributos_List?: any[],
    Filial_Data?: any
  ) {
    this.idItemEC = idItemEC;
    this.TItemEC = TItemEC;
    this.TItemECNom = TItemECNom;
    this.idItem = idItem;
    this.Marca = Marca;
    this.Codigo = Codigo;
    this.Nro = Nro;
    this.NombreItm = NombreItm;
    this.UniMed = UniMed;
    this.UniMedDeno = UniMedDeno;
    this.CodigoBarras = CodigoBarras;
    this.APedido = APedido;
    this.TipoIGV = TipoIGV;
    this.PV1 = PV1;
    this.PV2 = PV2;
    this.PV3 = PV3;
    this.PV4 = PV4;
    this.PV5 = PV5;
    this.PV6 = PV6;
    this.PVVenta = PVVenta;
    this.PorcDscto = PorcDscto;
    this.SaldoG = SaldoG;
    this.Otros = Otros;
    this.ImagenP = ImagenP;
    this.ClicCant = ClicCant;
    this.ValCant = ValCant;
    this.ValSum = ValSum;
    this.ValProm = ValProm;
    this.Habilitado = Habilitado;
    this.IncICBPER = Habilitado;
    this.Mostrar = Mostrar;
    this.OrdenIEC = OrdenIEC;
    this.Filial = Filial;
    this.items_Img_List = items_Img_List;
    this.itemsEC_Img_List = itemsEC_Img_List;
    this.tags = tags;
    this.colors = colors;
    this.OtrosEC = OtrosEC;
    this.itemsEC_Atributos_List = itemsEC_Atributos_List;
    this.Filial_Data = Filial_Data;
  }
}
// Color Filter
export interface ColorFilter {
  color?: ProductColor;
}
